import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Flex } from 'Components/Base';

import VideoBigPlayButton from './VideoBigPlayButton';

const FullSizeWrapper = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.9);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: ${({ active }) => (active ? 'flex' : 'none')};
  /* FYI: z-index is 3 for overlay can cover custom controller.
  See reference: vscode://file/{absolute path of odah-studyroom}/src/Components/VideoPlayer/components/VideoController.js */
  z-index: 3;
`;

const VideoFullSizeOverlay = ({ active, player, renderCustomVideoOverlay }) => (
  <FullSizeWrapper active={active}>
    {typeof renderCustomVideoOverlay === 'function' ? (
      renderCustomVideoOverlay(player)
    ) : (
      <VideoBigPlayButton size={VideoBigPlayButton.SIZE.BIG} />
    )}
  </FullSizeWrapper>
);

VideoFullSizeOverlay.propTypes = { active: PropTypes.bool };

export default VideoFullSizeOverlay;
